module.exports = __webpack_public_path__ + "media/images/emblems/Emmetten-coat_of_arms-6524d3e474ad360bb4aaf944c542a956.svg";